<!-- src/views/pages/administration/reports/p9-report.vue -->
<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />
        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2 dq-page-actions"
        >
          <!-- Year selector -->
          <div
            class="input-icon-end position-relative"
            style="min-width: 160px"
          >
            <input
              type="number"
              class="form-control"
              min="2015"
              max="2099"
              step="1"
              v-model.number="filters.year"
              @change="reload"
              :disabled="store.p9Loading"
              placeholder="Year"
            />
            <span class="input-icon-addon"><i class="ti ti-calendar"></i></span>
          </div>

          <!-- Optional search -->
          <div
            class="input-icon-end position-relative"
            style="min-width: 240px"
          >
            <input
              type="text"
              class="form-control"
              v-model.trim="filters.q"
              @keyup.enter="fetchList"
              :disabled="store.p9Loading"
              placeholder="Search name / emp id / email"
            />
            <span class="input-icon-addon"><i class="ti ti-search"></i></span>
          </div>

          <!-- Export -->
          <div class="dropdown">
            <a
              href="javascript:void(0);"
              class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
              data-bs-toggle="dropdown"
            >
              <i class="ti ti-file-export me-1"></i>Export
            </a>
            <ul class="dropdown-menu dropdown-menu-end p-3">
              <li>
                <a class="dropdown-item rounded-1" @click.prevent="exportCsv" v-can="'Reports.Export'">
                  <i class="ti ti-file-type-xls me-1"></i>Export P9 CSV
                </a>
              </li>
              <li>
                <a class="dropdown-item rounded-1" @click.prevent="exportZip" v-can="'Reports.Export'">
                  <i class="ti ti-archive me-1"></i>Export PDFs (ZIP)
                </a>
              </li>
            </ul>
          </div>

          <!-- Bulk email -->
          <div class="dropdown">
            <a
              href="javascript:void(0);"
              class="dropdown-toggle btn btn-primary d-inline-flex align-items-center"
              data-bs-toggle="dropdown"
              :class="{ disabled: bulkEmailLoading }"
            >
              <span
                v-if="bulkEmailLoading"
                class="spinner-border spinner-border-sm me-1"
              ></span>
              <i v-else class="ti ti-mail me-1"></i>Email
            </a>
            <ul class="dropdown-menu dropdown-menu-end p-3">
              <li>
                <a
                  class="dropdown-item rounded-1"
                  href="javascript:void(0);"
                  :class="{ disabled: bulkEmailLoading || !selectedEmployeeIds.length }"
                  @click.prevent="emailSelected"
                >
                  <i class="ti ti-user-check me-1"></i>
                  Email selected
                  <span v-if="selectedEmployeeIds.length" class="text-muted">
                    ({{ selectedEmployeeIds.length }})
                  </span>
                </a>
              </li>
              <li><hr class="dropdown-divider" /></li>
              <li>
                <a
                  class="dropdown-item rounded-1"
                  href="javascript:void(0);"
                  :class="{ disabled: bulkEmailLoading }"
                  @click.prevent="emailAll"
                >
                  <i class="ti ti-users me-1"></i>Email all employees ({{ filters.year }})
                </a>
              </li>
            </ul>
          </div>

          <div class="head-icons ms-2">
            <a id="collapse-header" @click="toggleHeader">
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- Table -->
      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>P9 Forms ({{ filters.year }})</h5>
          <div class="d-flex align-items-center gap-2 flex-wrap">
            <span
              v-if="selectedEmployeeIds.length"
              class="badge bg-primary-subtle text-primary border border-primary-subtle"
            >
              {{ selectedEmployeeIds.length }} selected
            </span>
            <button
              v-if="selectedEmployeeIds.length"
              class="btn btn-primary btn-sm"
              :disabled="bulkEmailLoading || store.p9Loading"
              @click="emailSelected"
            >
              <span
                v-if="bulkEmailLoading"
                class="spinner-border spinner-border-sm me-1"
              ></span>
              <i v-else class="ti ti-mail me-1"></i>
              Email selected
            </button>
            <button
              class="btn btn-white"
              :disabled="store.p9Loading"
              @click="reload"
            >
              <span
                v-if="store.p9Loading"
                class="spinner-border spinner-border-sm me-1"
              ></span>
              Refresh
            </button>
          </div>
        </div>

        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <P9ReportTable
              :rows="store.p9Rows"
              :loading="store.p9Loading"
              :total="store.p9Total"
              :page-size="store.p9PageSize"
              :current="store.p9Current"
              :year="filters.year"
              :selected-row-keys="selectedEmployeeIds"
              @change="onTableChange"
              @download="onDownload"
              @email="onEmail"
              @selection-change="onSelectionChange"
              :downloading-ids="downloadingIds"
              :emailing-ids="emailingIds"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
</template>

<style scoped>
@media (max-width: 767.98px) {
  .dq-page-actions {
    align-items: stretch !important;
  }

  .dq-page-actions > * {
    width: 100%;
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .dq-page-actions .dropdown,
  .dq-page-actions .dropdown-toggle,
  .dq-page-actions .form-control,
  .dq-page-actions .position-relative {
    width: 100%;
    min-width: 100% !important;
  }

  .custom-datatable-filter.table-responsive {
    margin-left: -1rem;
    margin-right: -1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    width: calc(100% + 2rem);
  }
}
</style>

<script setup>
import { reactive, ref, onMounted } from "vue";
import { useEmployeeSalaryStore } from "@/stores/employeeSalaryStore";
import P9ReportTable from "./p9-report-table.vue";
import { toast } from "@/utils/toast";

const title = "P9 Report";
const text = "HR";
const text1 = "P9 Report";

const store = useEmployeeSalaryStore();

const filters = reactive({
  year: store.p9Year || new Date().getFullYear(),
  page: store.p9Current || 1,
  per_page: store.p9PageSize || 25,
  q: "",
});

const downloadingIds = ref(new Set());
const emailingIds = ref(new Set());
const selectedEmployeeIds = ref([]);
const bulkEmailLoading = ref(false);

function onSelectionChange(ids) {
  selectedEmployeeIds.value = ids || [];
}

function toggleHeader() {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
}

async function fetchList() {
  const data = await store.fetchP9List({
    year: filters.year,
    page: filters.page,
    per_page: filters.per_page,
    search: filters.q || undefined,
  });

  // optional: keep local year in sync with backend default
  if (data?.year && data.year !== filters.year) {
    filters.year = data.year;
  }
}

function onTableChange(pagination) {
  filters.page = pagination.current;
  filters.per_page = pagination.pageSize;
  fetchList();
}

async function onDownload(record) {
  downloadingIds.value.add(record.id);
  try {
    await store.downloadP9(record.id, filters.year);
  } catch (e) {
    toast("Failed to download P9", "error");
  } finally {
    downloadingIds.value.delete(record.id);
  }
}

async function onEmail(record) {
  emailingIds.value.add(record.id);
  try {
    await store.emailP9(record.id, filters.year);
    toast("P9 emailed to employee.", "success");
  } catch (e) {
    const msg =
      e?.response?.data?.message || "Failed to email P9. Check the employee has a valid email.";
    toast(msg, "error");
  } finally {
    emailingIds.value.delete(record.id);
  }
}

async function emailSelected() {
  if (!selectedEmployeeIds.value.length || bulkEmailLoading.value) return;

  const count = selectedEmployeeIds.value.length;
  const ok = window.confirm(
    `Email P9 forms for ${filters.year} to ${count} selected employee(s)? Employees without a valid email will be skipped.`,
  );
  if (!ok) return;

  bulkEmailLoading.value = true;
  try {
    const data = await store.bulkEmailP9({
      year: filters.year,
      employeeIds: selectedEmployeeIds.value,
    });
    toast(data?.message || "P9 emails queued.", "success");
    selectedEmployeeIds.value = [];
  } catch (e) {
    const msg = e?.response?.data?.message || "Failed to queue P9 emails.";
    toast(msg, "error");
  } finally {
    bulkEmailLoading.value = false;
  }
}

async function emailAll() {
  if (bulkEmailLoading.value) return;

  const ok = window.confirm(
    `Email P9 forms for ${filters.year} to all employees with P9 data for this year? Employees without a valid email will be skipped.`,
  );
  if (!ok) return;

  bulkEmailLoading.value = true;
  try {
    const data = await store.bulkEmailP9({ year: filters.year });
    toast(data?.message || "P9 emails queued.", "success");
    selectedEmployeeIds.value = [];
  } catch (e) {
    const msg = e?.response?.data?.message || "Failed to queue P9 emails.";
    toast(msg, "error");
  } finally {
    bulkEmailLoading.value = false;
  }
}

async function exportZip() {
  try {
    await store.exportP9Zip(filters.year);
  } catch (e) {
    toast("Failed to export ZIP", "error");
  }
}

async function exportCsv() {
  try {
    await store.exportP9Csv(filters.year);
  } catch (e) {
    toast("Failed to export CSV", "error");
  }
}

async function reload() {
  filters.page = 1;
  selectedEmployeeIds.value = [];
  await fetchList();
}

onMounted(fetchList);
</script>


